// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTreatmentSummary_root__9MAoX","row":"ProcedureTreatmentSummary_row__rZfYv"};